import { render, staticRenderFns } from "./StatementsReport.vue?vue&type=template&id=66a2c6a5"
import script from "./StatementsReport.vue?vue&type=script&lang=js"
export * from "./StatementsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports